(ns ycweb.components.header
  (:require
   [rum.core :as rum]
   [ycweb.components.grid :as grid]
   [ycweb.components.cards :as cards]
   [ycweb.components.forms :as forms]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [util.string :as str]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [inflections.core :as inflections]))

(defn calculate-stocktake-percentages [{:keys [user total counted]}]
  {:total-counted (str (u/number-format (* (/ counted total) 100) 2) "%")
   :user-counted (str (u/number-format (* (/ user total) 100) 2) "%")})

(rum/defc profile < rum/reactive
  [app-atom setup]
  (let [user (cmn/curact app-atom :user)
        stocktake-stats (cmn/curact app-atom :stocktake-stats)
        stocktake-perc (calculate-stocktake-percentages stocktake-stats)
        {:keys [stocktake-view?]} (rum/react setup)]
    (into
      [:div]

      (concat
        [[:div.u-block-center.u-max-width-64.u-margin-bottom-16
          [:figure.user-account__image-wrapper
           (u/user-profile-pic user {:w 128 :h 128} "avatar  image  image--full")]]
         [:h3.u-text-center
          {:class (u/bem :heading [:medium-large])}
          (:name user)]
         [:p.u-text-16.u-text-center
          {:class (u/bem :paragraph [:flush])}
          (str "Store: " (cmn/curact app-atom [:selected-warehouse :displayname]))]
         [:p.paragraph.u-text-12.u-text-center.u-margin-top-8
          (str "APP Ver. " (cmn/curact app-atom [:device :version-name]) " | " "POS Build No. " (cmn/curact app-atom [:app :version]))]]

        (when-not stocktake-view?
          [[:div.u-hr]
           [:p
            {:class (u/bem :heading [:flush :standard])}
            [:b "Last 3 sales:"]]
           [:ul.order-calc
            (for [sale (cmn/curact app-atom [:recent-sales :sales])]
              [:li.order-calc__item
               [:span.order-calc__item-name (str "YC" (:refid sale))]
               [:span.order-calc__item-value
                (str (u/format-date :short (:dateadded sale)))]])]
           [:div.u-hr]
           [:ul.order-calc
            [:li.order-calc__item
             [:span.order-calc__item-name
              [:b "Total Today: "]]
             [:span.order-calc__item-value
              (str "R " (u/currency-format (cmn/curact app-atom [:recent-sales :daily-total])))]]]])

        [[:div.u-hr]
         [:p
          {:class (u/bem :heading [:flush :standard])}
          [:b "Weekly stocktake stats:"]]
         [:ul
          {:class (u/bem :tabular-list [:progress])}
          [:li.tabular-list__item
           [:div.tabular-list__item-progress
            [:aside.progress-bar-wrapper
             [:div.progress-bar
              [:div.progress-bar__value
               {:style {:width (:total-counted stocktake-perc)}}
               [:span.u-hidden-from-view (str (:total-counted stocktake-perc) " progress")]]]]]
           [:span.tabular-list__item-name "Store:"]
           [:span.tabular-list__item-value.u-text-right
            (str
              (:counted stocktake-stats) " / "
              (inflections/pluralize (:total stocktake-stats)
                "item"))]]
          [:li.tabular-list__item
           [:div.tabular-list__item-progress
            [:aside.progress-bar-wrapper
             [:div
              {:class (u/bem :progress-bar [:goal])}
              [:div.progress-bar__value
               {:style {:width (:total-counted stocktake-perc)}}
               [:span.u-hidden-from-view (:total-counted stocktake-perc)]]
              [:div.progress-bar__value
               {:style {:width (:user-counted stocktake-perc)}}
               [:span.u-hidden-from-view (str "of which you've counted " (:user-counted stocktake-perc))]]]]]
           [:span.tabular-list__item-name "You:"]
           [:span.tabular-list__item-value.u-text-right
            (str
              (:user stocktake-stats) " / "
              (inflections/pluralize (:total stocktake-stats)
                "item")
              " counted")]]]
         [:div.u-hr]
         [:p.paragraph.u-text-center
          "Your team is " (:total-counted stocktake-perc) " of the way done for the week"]]))))

(defmethod grid/modal-config :header/profile [_ _ _]
  {:body profile})

(defmethod grid/action :header/open-profile [app-atom config _]
  (comms/send :header/refresh-data {})
  (grid/open-modal app-atom :header/profile config))

(defmethod comms/receive :header/refresh-data [app-atom e]
  (swap! app-atom
    (fn [s]
      (assoc s
        :recent (:recent-sales e)
        :stocktake-stats (:stocktake-stats e)))))

(rum/defc header < rum/reactive [app-atom title {:keys [search-click]}]
  (let [menu-atom (rum/cursor app-atom :menu)
        user (cmn/curact app-atom :user)
        connection-open? (cmn/curact comms/comms [:open?])]
    [:div.header-wrapper
     [:header
      {:class (u/bem :header [(when (not connection-open?) :connection-error)])}
      [:nav.menu-button-wrapper
       [:a.menu-button
        {:on-click #(reset! menu-atom true)}
        [:i
         {:class (u/bem :icon [:menu :block])}
         [:span.u-hidden-from-view "Menu"]]]]
      [:div.header-title-wrapper [:h1.header-title title]]
      [:nav.user-account__image-wrapper
       [:a.user-account__image-button
        {:on-click #(grid/dispatch-action app-atom :header/open-profile  {})}
        (u/user-profile-pic user {:w 64 :h 64} "avatar  image  image--full")]]
      (when search-click
        [:nav.search-button-wrapper
         [:a.search-button
          {:on-click search-click}
          [:i
           {:class (u/bem :icon [:2-2 :search :block])}
           [:span.u-hidden-from-view "Search"]]]])
      [:div
       {:class
        (u/bem :header-process-bar
          [(when (cmn/curact (toaster/toast-cursor app-atom) :subtle-open) :is-open)])}
       [:div.header-process-bar__line]
       [:div.header-process-bar__line]
       [:div.header-process-bar__line]]]]))

(rum/defc search-line [term select-fn {:keys [title feature] :as product}]
  [:li.predictive-search__item
   [:a.predictive-search__link
    {:on-click #(select-fn product)}
    (let [i (str/index-of (str/lower-case title) (str/lower-case term))
          c (count term)]
      (if (nil? i)
        [:div.predictive-search__text
         [:span.predictive-search__product-text title]
         [:span.predictive-search__variation-text feature]]
        [:div.predictive-search__text
         [:span.predictive-search__product-text
          (subs title 0 i)
          [:b (subs title i (+ i c))]
          (subs title (+ i c))]
         [:span.predictive-search__variation-text feature]]))
    [:div.predictive-search__icon
     [:i
      {:class (u/bem :icon [:arrow-right :block])}
      [:span.u-hidden-from-view "View"]]]]])

(rum/defc search-panel < rum/reactive
  [app-atom modal? search-atom select-action]
  (let [state (rum/react search-atom)
        open? (or (:open state) modal?)
        productlist (take 3 (:products state))]

    [:div
     {:class
      (u/bem :search-overlay
        [(when open? :is-open)
         (when modal? :modal)])}

     [:div
      {:class (u/bem :search-bar-wrapper [(when modal? :modal)])}
      [:form.search-bar
       (when-not modal?
         [:nav.search-bar__close
          [:a.menu-button
           {:on-click #(swap! search-atom assoc :open false)}
           [:i
            {:class (u/bem :icon [:close :block])}
            [:span.u-hidden-from-view "Close Search"]]]])

       ;; Sneaky trick: only render this element in when open?, so that it grabs auto-focus
       (when open?
         (forms/input-raw
           "Search products"
           (rum/cursor search-atom :input)
           {:type :search :class :search-bar__input
            :auto-focus (cmn/auto-focus? app-atom)}))

       [:div.search-bar__button
        [:a.search-button.u-input-button-reset
         [:i
          {:class (u/bem :icon [:search :block])}
          [:span.u-hidden-from-view "Search"]]]]]

      (cond
        (:searching state)
        [:ul.predictive-search
         [:li.predictive-search__item
          [:a.predictive-search__link
           [:div.predictive-search__text
            "Searching..."]]]]

        (:clear state)
        nil

        (empty? productlist)
        [:ul.predictive-search
         [:li.predictive-search__item
          [:a.predictive-search__link
           [:div.predictive-search__text
            "No products found"]]]]

        :else
        [:ul.predictive-search
         (concat
           (map (partial search-line (:input state)
                  #(grid/dispatch-action app-atom select-action {:product %})) productlist)
           [[:li.predictive-search__item.predictive-search__all-results
             [:a
              {:on-click #(grid/dispatch-action app-atom :sell/search-results {})
               :class (u/bem :button [:muted :standard :text-default])}
              "View All Results"]]])])]]))

(rum/defc search < rum/reactive [app-atom]
  (search-panel app-atom false
    (rum/cursor-in app-atom [:sell :search])
    :sell/search-results)

  (let [search-atom (rum/cursor-in app-atom [:sell :search])
        state (rum/react search-atom)
        open? (:open state)
        productlist (take 3 (:products state))]
    [:div {:class (u/bem :search-overlay [(when open? :is-open)])}
     [:div.search-bar-wrapper
      [:form.search-bar
       [:nav.search-bar__close
        [:a.menu-button
         {:on-click #(swap! search-atom assoc :open false)}
         [:i
          {:class (u/bem :icon [:close :block])}
          [:span.u-hidden-from-view "Close Search"]]]]

       ;; Sneaky trick: only render this element in when open?, so that it grabs auto-focus
       (when open?
         (forms/input-raw
           "Search products"
           (rum/cursor search-atom :input)
           {:class :search-bar__input
            :no-border true
            :auto-focus (cmn/auto-focus? app-atom)}))

       [:div.search-bar__button
        [:a.search-button.u-input-button-reset
         [:i
          {:class (u/bem :icon [:search :block])}
          [:span.u-hidden-from-view "Search"]]]]]

      (cond
        (:searching state)
        [:ul.predictive-search
         [:li.predictive-search__item
          [:a.predictive-search__link
           [:div.predictive-search__text
            "Searching..."]]]]

        (:clear state)
        nil

        (empty? productlist)
        [:ul.predictive-search
         [:li.predictive-search__item
          [:a.predictive-search__link
           [:div.predictive-search__text
            "No products found"]]]]

        :else
        [:ul.predictive-search
         (concat
           (map (partial search-line (:input state)
                  #(grid/dispatch-action app-atom :sell/search-results {:product %})) productlist)
           [[:li.predictive-search__item.predictive-search__all-results
             [:a
              {:on-click #(grid/dispatch-action app-atom :sell/search-results {})
               :class (u/bem :button [:muted :standard :text-default])}
              "View All Results"]]])])]]))

(rum/defc search-results < rum/reactive
  [app-atom
   {:keys [addcart-fn delivery-fn options-fn notify-fn]}]
  (let [search-atom (rum/cursor-in app-atom [:sell :search])
        state (rum/react search-atom)
        productlist (:products state)]
    [:div.section
     (grid/row {}
       (grid/cell {:span 2 :cols 3}
         [:h2.u-text-center {:class (u/bem :heading [:standard])}
          (str "Search result for \"" (:input state) "\"")]))

     (cmn/row-full
       (into [:div]
         (map
           (partial cards/product-card
             {:options-fn options-fn
              :notify-fn notify-fn
              :addcart-fn addcart-fn
              :delivery-fn delivery-fn}) productlist)))]))

(rum/defc menu-item [{:keys [click-fn label icon text-style alert?] :as item}]
  [:li.main-menu__item
   [:a.main-menu__link
    {:on-click #(when click-fn (click-fn item))}
    [:div.main-menu__icon [:i {:class (u/bem :icon [icon :block (:side-menu-icon-size item)])}]]
    [:div.main-menu__text
     {:class (u/bem (when (= text-style "negative") :u-text-status-negative) [])} label]
    (when alert?
      [:div.main-menu__alert])]])

(rum/defc menu-overlay < rum/reactive [open-atom]
  [:div.main-nav-overlay
   {:class (u/bem :main-nav-overlay [(when (rum/react open-atom) :is-open)])
    :on-click #(reset! open-atom false)}])

(rum/defc menu < rum/reactive [app-atom menu-items]
  (let [open-atom (rum/cursor app-atom :menu)
        open? (rum/react open-atom)
        user (cmn/curact app-atom :user)
        presence (cmn/curact app-atom :presence)]
    [:nav
     {:class (u/bem :main-nav [(when open? :is-open)])
      :role "navigation"}
     [:div.user-account
      [:figure.user-account__image-wrapper
       (u/user-profile-pic user {:w 128 :h 128} "avatar  image  image--full")]
      [:div.user-account__details
       [:h1.user-account__name (:name user)]
       [:p.user-account__login (str "Store: " (cmn/curact app-atom [:selected-warehouse :displayname]))]
       [:p.user-account__build-no (str "APP Ver. " (cmn/curact app-atom [:device :version-name]) " | " "POS Build No. " (cmn/curact app-atom [:app :version]))]]
      (when (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
        [:p.user-account__build-no
         (str "CTX: " (:current-context presence))])
      [:a.main-nav__close-button
       {:on-click #(reset! open-atom false)}
       [:i
        {:class (u/bem :icon [:is-light :close :block])}
        [:span.u-hidden-from-view "Close Menu"]]]]
     (into
       [:ul.main-menu]
       (map
         #(menu-item
            (assoc %
              :click-fn
              (fn [{:keys [select-fn] :as item}]
                (reset! open-atom false)
                (when select-fn (select-fn item)))))
         menu-items))]))

